import { render, staticRenderFns } from "./ModalSupplier.vue?vue&type=template&id=2703193d&scoped=true&"
import script from "./ModalSupplier.vue?vue&type=script&lang=js&"
export * from "./ModalSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2703193d",
  null
  
)

export default component.exports